import { Version } from "../version";

//App.Common.Logging
export class Logging {
    static maxMessageLength = 2000;
    static clientVersionLogMessage = ", Client version: " + Version.ClientVersion;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static logConsole(...data: any[]): void {
        if (console && console.log) {
            console.log(data);
        }
    }

    static logErrorEvent(event: ErrorEvent): void {
        Logging.sendLog("logerror", null, event);
    }

    static logError(message: string): void {
        Logging.sendLog("logerror", message);
    }

    static logWarning(message: string): void {
        Logging.sendLog("logwarning", message);
    }

    static logInfo(message: string): void {
        Logging.sendLog("loginfo", message);
    }

    static logDebug(message: string): void {
        Logging.sendLog("logdebug", message);
    }

    static sendLog(type: string, message: string, event?: ErrorEvent) {
        message = Logging.appendDebuggingInfo(message, event);

        Logging.logConsole(message);

        const req = new XMLHttpRequest();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data: any = {
            message: Logging.limitMessageAndAppendVersion(message),
            __RequestVerificationToken: $("input[name=\"__RequestVerificationToken\"]").val()
        }
        req.open("POST", "/api/logging/" + type, true);
        req.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        req.send(JSON.stringify(data));
    }

    private static appendDebuggingInfo(message: string, event?: ErrorEvent): string {
        if (!Logging.isNullOrUndefined(event)) {
            message = "ErrorEvent: ";
            message += Logging.useDefaultIfEmpty(Logging.getErrorEventMessage(event), ", <no error event message> ErrorEvent: " + JSON.stringify(event));
            message += "\n" + Logging.getPageInfo();
            message += "\n" + Logging.useDefaultIfEmpty(Logging.getErrorEventStackTrace(event), "<no stack trace available>");

            if (!Logging.isNullOrUndefined(event.filename)) {
                message += `\nin file "${event.filename}"`;
                if (!Logging.isNullOrUndefined(event.lineno)) {
                    message += ` line ${event.lineno}`;
                }
                if (!Logging.isNullOrUndefined(event.colno)) {
                    message += ` column ${event.colno}`;
                }
            }
        } else {
            message = Logging.useDefaultIfEmpty(message, "<no error message>");
            message += "\n" + Logging.getPageInfo();
            message += "\n" + Logging.useDefaultIfEmpty(Logging.getStackTrace(), "<no stack trace available>");
        }
        return message;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isNullOrUndefined(obj: any): boolean {
        return typeof obj === "undefined" || obj == null;
    }
    private static useDefaultIfEmpty(message: string, defaultMessage: string): string {
        return (message == null || message.length == 0) ? defaultMessage : message;
    }
    private static getErrorEventMessage(event: ErrorEvent): string {
        if (!Logging.isNullOrUndefined(event.error)) {
            return Logging.isNullOrUndefined(event.error.message) ? event.error : event.error.message;
        }
    }
    private static getPageInfo(): string {
        return `    at page "${location.href}"`;
    }

    private static getErrorEventStackTrace(event: ErrorEvent): string {
        return Logging.isNullOrUndefined(event.error) || Logging.isNullOrUndefined(event.error.stack) ? Logging.getStackTrace() : event.error.stack;
    }
    private static getStackTrace(): string {
        return (new Error())?.stack?.replace("Error\n", "");
    }

    static logBrowserInfos() {
        const ww = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const wh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        const sw = window.screen.width;
        const sh = window.screen.height;

        let message = "OS:" + navigator.appVersion;
        message += "; Agent:" + navigator.userAgent;
        message += "; Window Size:" + ww + "x" + wh;
        message += "; Screen Size:" + sw + "x" + sh;
        Logging.logInfo(message);
    }

    static limitMessageAndAppendVersion(message: string): string {
        return message.substring(0, Logging.maxMessageLength - Logging.clientVersionLogMessage.length) + Logging.clientVersionLogMessage;
    }
}
